if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('.upsell-slider');
        this.slider_template = this.querySelector('#slider_template');

        const _this = this;
        setTimeout(function () {
          _this.data = Debutify.widgets['cart_upsell'];
          _this.cartItems = Debutify.cart.items;
          _this.init();
        }, 1000);
      }

      async init() {
        await this.getEligibleUpsell();
      }

      async getEligibleUpsell() {
        let cartHandles = this.cartItems.map((item) => item.handle);

        let eligibleUpsell = this.data.specific.filter((item) => {
          return cartHandles.includes(item.product_trigger);
        });

        if (!eligibleUpsell.length) {
          this.upsellProduct = this.data.global;
        } else {
          this.upsellProduct = eligibleUpsell;
        }

        if (!this.upsellProduct) return;

        let slider = this.slider_template.innerHTML;
        let slides = '';

        const fetchPromises = [];
        this.upsellProduct.forEach((item) => {
          (item.product_offers || []).forEach((offer) => {
            if (!offer || !offer.handle) return;
            const params = new URLSearchParams({ view: 'internal-cart-upsell-product' });
            fetchPromises.push(
              fetch(`/products/${offer.handle}?${params.toString()}`)
                .then((r) => (r.ok ? r.text() : ''))
                .catch(() => '')
            );
          });
        });

        const htmlResults = await Promise.all(fetchPromises);
        slides = htmlResults.join('');
        if (!slides) {
          this.classList.add('hidden');
          return;
        }

        if (this.dataset.hideInCart === 'true') {
          const parser = new DOMParser();
          const slidesDoc = parser.parseFromString(`<ul>${slides}</ul>`, 'text/html');
          const slideItems = slidesDoc.querySelectorAll('li.grid__item');

          slideItems.forEach((slide) => {
            const handle = slide.getAttribute('data-handle');
            if (cartHandles.includes(handle)) {
              slide.remove();
            }
          });

          slides = slidesDoc.body.querySelector('ul').innerHTML;
        }

        slider = Debutify.replaceVariables(slider, { slides: slides });
        this.slider.innerHTML = slider;
        this.classList.remove('hidden');
        if (this.querySelector('.card-upsell-slider li')) {
          if (this.querySelectorAll('.card-upsell-slider li').length < 3 && this.dataset.alignment === 'true') {
            this.querySelector('.card-upsell-slider').classList.add('justify-content-center');
          }
        } else {
          this.classList.add('hidden');
        }
      }
    }
  );
}
